/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0-nightly.2026.9.5",
    versionName: "0.6.0-nightly.2026.9.5",
    versionChannel: "nightly",
    buildDate: "2026-09-05T00:17:23.873Z",
    commitHash: "34a8c83cdf2669be0005e97bbdbdcd69a7b367af",
};
